'use strict';

var PricingSummaryPanelToolbarController = function PricingSummaryPanelToolbarController($scope, $rootScope, searchCriteriaConstantsService, dataRetrieverConstantsService) {
  $scope.initialScreen = searchCriteriaConstantsService.PRICING_SUMMARY;
  $scope.screen = dataRetrieverConstantsService.PRICING_SUMMARY_SCREEN;
  $scope.isFareChangeGridVisible = false;
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
};
PricingSummaryPanelToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'DataRetrieverConstantsService'];
module.exports = PricingSummaryPanelToolbarController;